
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Cog, Globe, Link, Users, User } from 'lucide-react';
import SystemSettingsTab from './SystemSettingsTab';
import DomainSettingsTab from './DomainSettingsTab';
import IntegrationsSettingsTab from './IntegrationsSettingsTab';
import BusinessSignupPlansTab from '@/components/superadmin/BusinessSignupPlansTab';
import SuperAdminProfileTab from '@/components/superadmin/SuperAdminProfileTab';

interface SuperAdminSettingsTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  onSaveSettings: (section: string) => void;
}

const SuperAdminSettingsTabs: React.FC<SuperAdminSettingsTabsProps> = ({
  activeTab,
  setActiveTab,
  onSaveSettings
}) => {
  const handleSaveIntegrations = async (): Promise<void> => {
    onSaveSettings('integrations');
    return Promise.resolve();
  };

  const handleSaveBusinessPlans = async (): Promise<void> => {
    onSaveSettings('businessPlans');
    return Promise.resolve();
  };

  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
      <TabsList className="mb-8 grid w-full grid-cols-6">
        <TabsTrigger value="profile" className="flex items-center">
          <User className="mr-2 h-4 w-4" />
          <span>Profile</span>
        </TabsTrigger>
        <TabsTrigger value="system" className="flex items-center">
          <Cog className="mr-2 h-4 w-4" />
          <span>System</span>
        </TabsTrigger>
        <TabsTrigger value="domain" className="flex items-center">
          <Globe className="mr-2 h-4 w-4" />
          <span>Domains</span>
        </TabsTrigger>
        <TabsTrigger value="integrations" className="flex items-center">
          <Link className="mr-2 h-4 w-4" />
          <span>Integrations</span>
        </TabsTrigger>
        <TabsTrigger value="businessPlans" className="flex items-center">
          <Users className="mr-2 h-4 w-4" />
          <span>Business Plans</span>
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="profile">
        <SuperAdminProfileTab />
      </TabsContent>
      
      <TabsContent value="system">
        <SystemSettingsTab onSaveSettings={onSaveSettings} />
      </TabsContent>
      
      <TabsContent value="domain">
        <DomainSettingsTab onSaveSettings={onSaveSettings} />
      </TabsContent>
      
      <TabsContent value="integrations">
        <IntegrationsSettingsTab onSaved={handleSaveIntegrations} />
      </TabsContent>
      
      <TabsContent value="businessPlans">
        <BusinessSignupPlansTab onSaved={handleSaveBusinessPlans} />
      </TabsContent>
    </Tabs>
  );
};

export default SuperAdminSettingsTabs;
